import { connect } from 'react-redux'
import { loginActions, authActions } from '../../actions'
import AuthErrors from './AuthErrors'
import { color, patterns, pxToRem } from '../../utils';
import { Link } from 'react-router-dom'
import { SimpleLoader, Pace } from '../../components/loaders'
import Box from '../../components/Box'
import Logo from '../../components/Logo'
import Button from '../../components/Form/Button'
import FormControl from '../../components/Form/FormControl'
import InputError from '../../components/Form/InputError'
import Input from '../../components/Form/Input'
import React, { Component } from 'react'
import styled from 'styled-components'

const WrapperLogin = styled.div`
  max-width: ${pxToRem(960)};
  width: 100%;
  margin: auto;
  padding: 0 ${pxToRem(15)};
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${pxToRem(15)};
  @media only screen and (max-width: 765px) {
    flex-direction: column;
  }
`

const LogoWrapper = styled(Logo)`
  margin: ${pxToRem(30)} ${pxToRem(10)};
  max-width: ${pxToRem(350)};
  ${({name}) => {
    if(name === 'client') {
      return `margin-bottom: ${pxToRem(40)};`
    }
    if(name === 'exo') {
      return 'margin-top: auto;'
    }
  }}
`

const WrapperLoader = styled.div`
  height: ${pxToRem(400)};
  position: relative;
  width: 100%;
`

const Title = styled('h1')`
  text-align: center;
  color: ${color.primary};
  opacity: .7;
  font-size: ${pxToRem(26)};
  font-weight: 400;
  margin-bottom: ${pxToRem(15)};
`

const FormActions = styled('div')`
  margin-top: ${pxToRem(45)};
  margin-bottom: ${pxToRem(10)};

  &:after {
    display: block;
    content: '';
    clear: both;
  }
`

const ContainerForm = styled(Box)`
  position: relative;
  z-index: 2;
  width: ${pxToRem(320)};
  a {
    float: left;
    color: ${color.secondary};
    line-height: ${pxToRem(35)};
  }

  button {
    float: right;
  }
`

const WrapperBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 100vh;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  * {
    box-sizing: border-box;
  }
`

const WrapperLink = styled(Link)`
  font-size: ${pxToRem(14)};
`

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
        user: {
            email: ''
        },
        submitted: false,
        emailError: null
    };
  }

  componentDidMount() {
    this.props.clearErrors()
    this.props.stopFetching()
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    const { user } = this.state;
    const { clearErrors } = this.props
    clearErrors()

    this.setState({
        user: {
            ...user,
            [name]: value
        },
        submitted: false,
        emailError: null
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();

    this.setState({ submitted: true });

    const { user } = this.state

    let emailValid = this.validateEmail();

    if (emailValid) {
      this.props.fetchRecoverPassword(user).then(() => {
        this.props.router.history.push('/')
      })
    }
  }

  validateEmail = () => {
    const { user } = this.state

    if (!user.email) {
      this.setState({ emailError: 'E-mail é obrigatório' });
      return false
    } else if (user.email && !patterns.email().test(String(user.email).toLowerCase())){
      this.setState({ emailError: 'E-mail inválido' });
      return false
    }

    return true
  }

  render() {
    const { user, submitted, emailError } = this.state;
    const { auth_error, fetching } = this.props

    return (
      <WrapperBox>
        <LogoWrapper name="client" with="200" height="100" />
        <WrapperLogin>
          {!!fetching && (
            <Pace>
              <WrapperLoader>
                <SimpleLoader />
              </WrapperLoader>
            </Pace>
          )}
          <ContainerForm>
            <Title>Recuperar senha:</Title>

            <AuthErrors authError={auth_error} fetching={fetching} />

            <form onSubmit={this.handleSubmit}>
              <FormControl>
                <Input name="email" autoFocus={true} label='Email' display="block" value={ user.email } onChange={ this.handleChange }/>
                { (submitted && emailError) && <InputError>{ emailError }</InputError> }
              </FormControl>
              <FormActions>
                <WrapperLink to="/entrar">Voltar para o login</WrapperLink>

                <Button>Recuperar</Button>
              </FormActions>
            </form>
          </ContainerForm>
        </WrapperLogin>
        <LogoWrapper name="exo"/>
      </WrapperBox>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  fetchRecoverPassword: user => {
    return dispatch(loginActions.fetchRecoverPassword(user))
  },
  clearErrors: () => {
    return dispatch(loginActions.clearErrors())
  },
  stopFetching: () => {
    return dispatch(authActions.stopFetching())
  }
})

const mapStateToProps = state => ({
  fetching: state.auth.is_fetching,
  auth_error: state.authResponse.error
})

export default connect(mapStateToProps, mapDispatchToProps)(Login)



// WEBPACK FOOTER //
// ./src/containers/Login/RecoverPassword.js